import { useState, useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Stats from './components/Stats';
import WorkMethod from './components/WorkMethod';
import WhenNeedLawyer from './components/WhenNeedLawyer';
import Location from './components/Location';
import ContactInfo from './components/ContactInfo';
import Footer from './components/Footer';

export default function Home() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header isScrolled={isScrolled} />
      <Hero />
      <About />
      <Services />
      <Stats />
      <WorkMethod />
      <WhenNeedLawyer />
      <Location />
      <ContactInfo />
      <Footer />
    </div>
  );
}